<template>
  <div class="mycontent">
    <div class="top-area">
      <div class="item">
        <div class="label">经纬度:</div>
        <div class="desc">
          <el-tag> E{{ toFixed(config.lon, 6) }} </el-tag>
          <el-divider direction="vertical"></el-divider>
          <el-tag> N{{ toFixed(config.lat, 6) }} </el-tag>
        </div>
      </div>
      <div class="item">
        <div class="label">高度:</div>
        <div class="desc">
          <el-select v-model="datasetHeight" placeholder="选择高度">
            <el-option
              v-for="(v, i) in heightList"
              :key="i"
              :label="v + 'm'"
              :value="v"
            ></el-option>
          </el-select>
        </div>
      </div>
    </div>
    <div class="middle-area">
      <div class="row">
        <div class="row-item">
          <div class="key"><span>高度</span> :</div>
          <div class="value">
            <el-tag> {{ datasetHeight || '-' }} m</el-tag>
          </div>
        </div>
        <div class="row-item">
          <div class="key"><span>海拔</span> :</div>
          <div class="value">
            <el-tag>{{ summaryData.altitude || '-' }} m</el-tag>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="row-item">
          <div class="key"><span>空气密度</span> :</div>
          <div class="value">
            <el-tag> {{ summaryData.airDensity || '-' }} kg/m³ </el-tag>
          </div>
        </div>
        <div class="row-item">
          <div class="key"><span>平均风速</span> :</div>
          <div class="value">
            <el-tag> {{ summaryData.windSpeed || '-' }} m/s</el-tag>
          </div>
        </div>
        <!-- <div class="row-item">
          <div class="key"><span>发电小时</span> :</div>
          <div class="value">
            <el-tag>{{ summaryData.fullLoadHour || '-' }} h </el-tag>
          </div>
        </div> -->
      </div>
      <div class="row">
        <div class="row-item">
          <div class="key"><span>风功率密度</span> :</div>
          <div class="value">
            <el-tag>{{ summaryData.powerDensity || '-' }} W/㎡</el-tag>
          </div>
        </div>
        <div class="row-item">
          <div class="key"><span>风切变</span> :</div>
          <div class="value">
            <el-tag>{{ summaryData.shearExp || '-' }}</el-tag>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="row-item">
          <div class="key"><span>A值</span> :</div>
          <div class="value">
            <el-tag>{{ summaryData.weibullA || '-' }}</el-tag>
          </div>
        </div>
        <div class="row-item">
          <div class="key"><span>K值</span> :</div>
          <div class="value">
            <el-tag>{{ summaryData.weibullK || '-' }}</el-tag>
          </div>
        </div>
        
      </div>
    </div>
  </div>
</template>
<script>
import {
  toFixed,
} from '../views/plan/utils';
export default {
  props: {
    summaryData: {
      type: Object,
      default: () => {}
    }
  },
  methods: {
    toFixed
  }
};
</script>